export type NewsMockItem = {
  id: number;
  slug: string;
  category: string;
  title: string;
  content: string;
  publishedAt: string;
};

export const newsCategories: string[] = ['門市公告', '優惠活動', '社會福利', '活動花絮', '產品新訊', '優質服務'];

export const newsItems: NewsMockItem[] = [
  {
    id: 1,
    slug: 'snq-national-quality-award',
    category: '門市公告',
    title: '【獲獎肯定】國家級肯定！富聆助聽器 榮獲SNQ國家品質標章',
    content: '<p>富聆助聽器榮獲 SNQ 國家品質標章認證，這是台灣醫療與健康照護領域最具公信力的品質獎項之一，代表富聆聽在產品品質與服務流程上皆通過國家級嚴格審核。</p><p>感謝所有客戶的信任與支持，我們將持續精進聽力照護服務，做為您聽力健康最安心的選擇。</p>',
    publishedAt: '2025-11-24 09:00:00',
  },
  {
    id: 2,
    slug: 'store-holiday-notice-2025-10',
    category: '門市公告',
    title: '【門市公告】富聆門市 公休異動通知',
    content: '<p>因應人力調度，部分門市 10 月份公休日將有異動，詳細異動日期請洽各門市服務人員，造成不便敬請見諒。</p>',
    publishedAt: '2025-10-01 09:00:00',
  },
  {
    id: 3,
    slug: 'recruitment-2025-03',
    category: '門市公告',
    title: '【門市公告】富聆徵才訊息',
    content: '<p>富聆聽誠摯邀請對聽力照護有熱忱的您加入我們的團隊，歡迎持相關證照或有意投身聽力健康產業的朋友來信應徵。</p>',
    publishedAt: '2025-03-07 09:00:00',
  },
  {
    id: 4,
    slug: 'autumn-promotion-2025',
    category: '優惠活動',
    title: '【優惠活動】秋季聽力健檢優惠開跑',
    content: '<p>即日起預約聽力檢測，即可享有指定助聽器選配折扣，詳情請洽門市或線上預約。</p>',
    publishedAt: '2025-09-15 09:00:00',
  },
  {
    id: 5,
    slug: 'hearing-subsidy-guide-2025',
    category: '社會福利',
    title: '【社會福利】各縣市助聽器補助申請懶人包',
    content: '<p>整理各縣市政府對聽障者購買助聽器的補助申請流程與所需文件，協助您順利申請補助。</p>',
    publishedAt: '2025-06-20 09:00:00',
  },
  {
    id: 6,
    slug: 'community-hearing-checkup-2025',
    category: '活動花絮',
    title: '【活動花絮】社區聽力篩檢活動圓滿落幕',
    content: '<p>感謝各界熱情參與本次社區聽力篩檢活動，富聆聽力師團隊為超過百位長者提供免費聽力篩檢服務。</p>',
    publishedAt: '2025-05-10 09:00:00',
  },
  {
    id: 7,
    slug: 'new-product-launch-2025',
    category: '產品新訊',
    title: '【產品新訊】全新一代智慧助聽器上市',
    content: '<p>搭載 AI 降噪與藍牙連線功能的全新助聽器系列正式上市，歡迎預約試戴體驗。</p>',
    publishedAt: '2025-04-18 09:00:00',
  },
  {
    id: 8,
    slug: 'service-quality-upgrade-2025',
    category: '優質服務',
    title: '【優質服務】售後保養服務全面升級',
    content: '<p>為提供更完善的售後體驗，富聆聽力保養服務全面升級，提供更即時的到府清潔與調校服務。</p>',
    publishedAt: '2025-02-12 09:00:00',
  },
];
